import type { Stylable } from '@core/utils/types'
import { IconSquare } from '@design/components/icons/icon-square/IconSquare'
import { cn } from 'cn'
import { X } from 'lucide-react'
import type {
  ElementType,
  MouseEventHandler,
  PropsWithChildren,
  ReactNode,
} from 'react'

export type MessageProps = PropsWithChildren<Stylable> & {
  icon: ElementType
  iconClassName?: string
  title?: string
  action?: ReactNode
  role?: 'alert' | 'status'
  onClose?: MouseEventHandler
}

export function Message({
  icon,
  iconClassName,
  title,
  children,
  action,
  className,
  role,
  onClose,
}: MessageProps) {
  return (
    <div
      role={role}
      className={cn(
        'flex items-center gap-3 rounded-xl border border-border bg-background px-4 py-3',
        onClose && 'relative pe-9',
        className
      )}
    >
      <IconSquare icon={icon} className={cn('size-8', iconClassName)} />
      <div className='flex min-w-0 flex-1 flex-col'>
        {title && (
          <h5 className='m-0 font-semibold text-foreground'>{title}</h5>
        )}
        {children && (
          <p className='m-0 text-muted-foreground text-sm'>{children}</p>
        )}
      </div>
      {action && <div className='shrink-0'>{action}</div>}
      {onClose && (
        <button
          type='button'
          onClick={onClose}
          className='absolute top-2 right-2 appearance-none rounded-sm p-1 text-muted-foreground hover:text-foreground'
        >
          <X className='size-3' />
        </button>
      )}
    </div>
  )
}
